import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplatePrintRequestDeliveryId = Brand<number, 'MediaTemplatePrintRequestDeliveryId'>;
export const MediaTemplatePrintRequestDeliveryId = createBranded<MediaTemplatePrintRequestDeliveryId>();
